import { escapeHtml } from 'shared/helpers/HTMLSanitizer';

// MailboxHelper#replacement_attachment_html writes inline attachments into the
// stored plain text as `<img src="URL" alt="NAME">` or
// `<a href="URL">NAME</a><br>`, where URL is an Active Storage blob URL.
// Only these exact shapes are rendered; any other markup stays text.
const BACKEND_ATTACHMENT =
  /<img src="(https?:\/\/[^\s"<>]+\/rails\/active_storage\/[^\s"<>]+)" alt="([^"<>]*)">|<a href="(https?:\/\/[^\s"<>]+\/rails\/active_storage\/[^\s"<>]+)">([^"<>]*)<\/a><br>/g;

const attachmentHtml = (imgSrc, alt, href, name) =>
  imgSrc
    ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(alt)}">`
    : `<a href="${escapeHtml(href)}">${escapeHtml(name)}</a><br>`;

const lineToHtml = line => {
  let html = '';
  let last = 0;
  Array.from(line.matchAll(BACKEND_ATTACHMENT)).forEach(match => {
    const [tag, imgSrc, alt, href, name] = match;
    html += escapeHtml(line.slice(last, match.index));
    html += attachmentHtml(imgSrc, alt, href, name);
    last = match.index + tag.length;
  });
  return html + escapeHtml(line.slice(last));
};

/**
 * Turns a plain-text email body into HTML for `Letter`: one div per line,
 * with an empty line kept as a non-breaking space so it keeps its height.
 * The text is escaped, so `John <john@example.com> wrote:` stays visible
 * instead of being parsed as a tag. Inline attachments that the backend
 * embedded into the text are still rendered.
 * @param {string} text - plain-text email body
 * @returns {string} HTML
 */
export const plainTextToHtml = text => {
  if (!text) return text;

  return text
    .split('\n')
    .map(line =>
      line.trim() === ''
        ? '<div>&nbsp;</div>'
        : `<div>${lineToHtml(line)}</div>`
    )
    .join('');
};
